import { gtmEvent__engagedByTime } from "@/helpers/gtm-events";
import { GTM_ENGAGEMENT_TIME } from "@/enums/gtm-events";

export const gtmEngagement = {
  data() {
    return {
      gtmEngagementTimeouts: {
        [GTM_ENGAGEMENT_TIME.FIRST]: null,
        [GTM_ENGAGEMENT_TIME.SECOND]: null
      }
    };
  },
  beforeDestroy() {
    Object.values(this.gtmEngagementTimeouts).forEach(value => {
      if (value) {
        clearTimeout(value);
      }
    });
  },
  methods: {
    async mixin__setGtmEngagementTimeouts() {
      await this.$nextTick(() => {
        Object.keys(this.gtmEngagementTimeouts).forEach(key => {
          this.gtmEngagementTimeouts[key] = setTimeout(() => {
            gtmEvent__engagedByTime({
              path: this.$route.path,
              pageName: this.$route.name,
              time: key
            });
          }, key * 1000);
        });
      });
    }
  }
};
